export default function scriptMenu(){
	document.addEventListener("DOMContentLoaded", function () {
		const headerContainer = document.querySelector('.header-container');
		const logoLink = document.getElementById('logo-link');
		const logoImage = logoLink.querySelector('img');
		const logoDefault = logoLink.getAttribute('data-logo-default');
		const logoAlterado = logoLink.getAttribute('data-logo-alterado');
		const menuToggle = document.querySelector('.menu-toggle');
		const menuOverlay = document.querySelector('.menu-overlay');
		const menuContent = document.querySelector('.menu-content');
		const closeMenuButtons = document.querySelectorAll('.close-menu');
	
		headerContainer.style.transition = 'background-color 0.3s ease';

		menuToggle.addEventListener('click', function() {
			menuOverlay.classList.add('show-menu');
			menuContent.classList.add('show-menu');
		});
	
		closeMenuButtons.forEach(function(button) {
			button.addEventListener('click', function() {
				menuOverlay.classList.remove('show-menu');
				menuContent.classList.remove('show-menu');

				const mobileDropdown = this.closest('.dropdown-menu-mobile');
				if (mobileDropdown) {
					mobileDropdown.classList.remove('show-dropdown-menu-mobile');
				}
			});
		});

		document.addEventListener('click', function(e) {
			const undoElement = e.target.closest('.undo-dropdown-menu-mobile');
			if (undoElement) {
					e.preventDefault();
					e.stopPropagation();
					
					const dropdown = undoElement.closest('.dropdown-menu-mobile');
					if (dropdown) {
							dropdown.classList.remove('show-dropdown-menu-mobile');
					}
			}
		});

		document.querySelectorAll('.header-menu nav a.dropdown-toggle').forEach(link => {
			link.style.transition = 'transform 0.5s ease-out, color 0.3s ease';
		});

		function updateMenuStyle() {
			const scrolled = window.scrollY > 0;
			const gwrapper = document.getElementById('gwrapper');
		
			let dropdownAberto = false;
			document.querySelectorAll('.dropdown-menu').forEach((menu) => {
				if (!menu.classList.contains('hidden')) {
					dropdownAberto = true;
				}
			});
		
			if (scrolled || dropdownAberto) {
				headerContainer.classList.add('menu-alterado');
				headerContainer.classList.remove('menu-padrao');
				headerContainer.style.backgroundColor = "#FFFFFF";
				logoImage.src = logoAlterado;
		
				document.querySelectorAll('.header-menu nav a.dropdown-toggle').forEach(link => {
					link.classList.remove('text-neutral-100');
					link.classList.add('text-brand-1');
		
					const dropdownId = link.getAttribute('data-dropdown-id');
					if (dropdownId) {
						const dropdownMenu = document.getElementById(dropdownId);
						const arrow = link.querySelector('svg');
		
						if (dropdownMenu && !dropdownMenu.classList.contains('hidden')) {
							link.style.color = "#4A9E4A";
							link.classList.add('font-semibold');
							if (arrow) {
								arrow.classList.remove("text-white", "text-brand-1");
								arrow.classList.add("text-brand-4");
								arrow.style.transform = "rotate(180deg)";
								arrow.style.transition = "transform 0.3s ease";
							}
						} else {
							link.style.color = "";
							link.classList.remove('font-semibold');
							if (arrow) {
								arrow.classList.remove("text-white", "text-brand-4");
								arrow.classList.add("text-brand-1");
								arrow.style.transform = "";
							}
						}
					}
				});
		
				if (gwrapper) {
					gwrapper.classList.remove('text-neutral-100');
					gwrapper.classList.add('text-brand-1');
		
					const languageLinks = gwrapper.querySelectorAll('a');
					languageLinks.forEach((link, index) => {
						if (index < languageLinks.length - 1) {
							link.style.borderRightColor = '#172B2D';
							link.style.transition = 'border-color 0.3s ease, color 0.3s ease';
						}
					});
				}
		
			} else {
				headerContainer.classList.add('menu-padrao');
				headerContainer.classList.remove('menu-alterado');
				headerContainer.style.backgroundColor = "transparent";
				logoImage.src = logoDefault;
		
				document.querySelectorAll('.header-menu nav a.dropdown-toggle').forEach(link => {
					link.classList.remove('text-brand-1');
					link.classList.add('text-neutral-100');
					link.style.color = "";
					link.classList.remove('font-semibold');
					const arrow = link.querySelector('svg');
					if (arrow) {
						arrow.classList.remove("text-brand-1", "text-brand-4");
						arrow.classList.add("text-white");
						arrow.style.transform = "";
					}
				});
		
				if (gwrapper) {
					gwrapper.classList.remove('text-brand-1');
					gwrapper.classList.add('text-neutral-100');
		
					const languageLinks = gwrapper.querySelectorAll('a');
					languageLinks.forEach((link, index) => {
						if (index < languageLinks.length - 1) {
							link.style.borderRightColor = '#FFF';
						}
					});
				}
			}
		}
		
		function handleSubChildHover() {
			document.querySelectorAll(".dropdown-menu li ul li").forEach((subChild) => {
				const anchor = subChild.querySelector("a");
				const arrowIcon = subChild.querySelector("svg");
		
				subChild.addEventListener("mouseenter", function () {
					if (anchor) {
						anchor.classList.remove("text-brand-1");
						anchor.classList.add("text-brand-4");
					}
					if (arrowIcon) {
						arrowIcon.style.opacity = "1";
						arrowIcon.style.transform = "translateX(5px)";
						arrowIcon.style.transition = "opacity 0.3s ease, transform 0.3s ease";
					}
				});
		
				subChild.addEventListener("mouseleave", function () {
					if (anchor) {
						anchor.classList.remove("text-brand-4");
						anchor.classList.add("text-brand-1");
					}
					if (arrowIcon) {
						arrowIcon.style.opacity = "0";
						arrowIcon.style.transform = "translateX(0)";
					}
				});
			});
		}
		
		handleSubChildHover();
		
		document.querySelectorAll(".dropdown-toggle").forEach((toggle) => {
			toggle.addEventListener("click", function (event) {
				event.preventDefault();
		
				const isMobile = window.matchMedia("(max-width: 1280px)").matches;
		
				const li = this.closest("li");
		
				function findDropdown(className) {
					let sibling = li.nextElementSibling;
					while (sibling) {
						if (sibling.classList.contains(className)) {
							return sibling;
						}
						sibling = sibling.nextElementSibling;
					}
					return null;
				}
		
				if (isMobile) {
					const mobileDropdown = findDropdown("dropdown-menu-mobile");
					if (mobileDropdown) {
						mobileDropdown.classList.add("show-dropdown-menu-mobile");
					}
				} else {
					const desktopDropdown = findDropdown("dropdown-menu");
					if (desktopDropdown) {
						desktopDropdown.classList.toggle("hidden");
					}
				}

				updateMenuStyle();
			});
		});
		
		document.addEventListener("click", function (event) {
			if (!event.target.closest(".dropdown-parent") && !event.target.closest(".dropdown-menu")) {
				document.querySelectorAll(".dropdown-menu").forEach((menu) => {
					menu.classList.add("hidden");
				});
				updateMenuStyle();
			}
		});

		window.addEventListener('scroll', updateMenuStyle);
		updateMenuStyle();

		setTimeout(function () {
			const gWrappers = document.querySelectorAll('.gtranslate_wrapper');
			
			gWrappers.forEach(gwrapper => {
				const languageLinks = gwrapper.querySelectorAll('a');
				
				languageLinks.forEach((link, index) => {
					if (index < languageLinks.length - 1) {
						link.style.borderRight = '1px solid #FFF';
						link.style.paddingRight = '6px';
						link.style.marginRight = '3px';
						link.style.transition = 'color 0.3s ease';
					}
				});
			});
		}, 10);
		
	});
}
